<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<!-- eslint-disable -->
<script>
	export default {
			created() {
				console.log('start load---')
			}
	}
</script>

<style>
	@import url("assets/css/app.css");
	@import url("https://at.alicdn.com/t/font_1275249_dmnfmv0s7v.css");
	@import url("https://at.alicdn.com/t/font_1907771_of8iidn0xk8.css");
</style>
